
import settings from "settings";
import { TOGGLE_LEAGUE_AND_DIVISION, TOGGLE_RATING_LIST, TOGGLE_RATING_ERROR, TOGGLE_RATING_FETCH, SET_CROSS_REALM_LADDER, SET_CURRENT_CLAN_ID, SET_CURRENT_SEASON, SET_CURRENT_REALM, SET_CURRENT_SEASON_TYPE } from "../Actions/ActionClanRating";

type Action = any

export const SEASON_TYPES = {
  REGULAR: 'regular',
  BRAWL: 'brawl'
};

export type State = {};

const initialState = {
  currentLeague: 0,
  currentDivision: 0,
  currentClanId: 0,
  currentSeason: settings.ladder.lastSeasonId,
  ratingLists: {},
  isError: false,
  isFetching: true,
  errorMessage: '',
  isCrossRealmLadder: settings.ladder.isCrossRealmLadderByDefault
};

export type IReducerRatings = (state: State, action: Action) => State;
export const ReducerRatings = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;

  }
};

export const clansRating = (state = initialState, action) => {
  let rating = [];
  let leagues = {};
  let divisions = [];

  switch (action.type) {
    case SET_CROSS_REALM_LADDER:
      return Object.assign({}, state, {
        isCrossRealmLadder: action.isCrossRealmLadder
      });

    case TOGGLE_LEAGUE_AND_DIVISION:
      return Object.assign({}, state, {
        currentLeague: action.league,
        currentDivision: action.division
      });

    case TOGGLE_RATING_LIST:
      if (action.ratingList) rating = action.ratingList;
      leagues = state.ratingLists;
      if (state.ratingLists[action.league]) divisions = state.ratingLists[action.league];
      return {
        ...state,
        ratingLists: {
          ...leagues,
          [action.league]: {
            ...divisions,
            [action.division]: rating
          }
        }
      };
    case SET_CURRENT_CLAN_ID:
      return Object.assign({}, state, {
        currentClanId: action.currentClanId
      });
    case TOGGLE_RATING_FETCH:
      return Object.assign({}, state, {
        isFetching: action.isFetching
      });

    case TOGGLE_RATING_ERROR:
      return Object.assign({}, state, {
        isError: action.isError,
        errorMessage: action.errorMessage
      });

    case SET_CURRENT_SEASON_TYPE:
      return Object.assign({}, state, {
        currentSeasonType: action.currentSeasonType
      });

    case SET_CURRENT_SEASON:
      return Object.assign({}, state, {
        currentSeason: action.currentSeason
      });

    case SET_CURRENT_REALM:
      return Object.assign({}, state, {
        currentRealm: action.currentRealm
      });

    default:
      return state;

  }
};